import { Translate } from "next-translate"
import useTranslation from "next-translate/useTranslation"

import { IProject, ProjectProgress } from "@api/schema"
import { DynamicTranslate } from "@services/i18n"

interface IProps {
  project: IProject
}

// we export this as a function that returns a simple string so it can be easily used as parameter
// in other translations
export const projectNameText = (project: IProject, t: Translate): string =>
  project && project.progress === ProjectProgress.Idea
    ? t("project.idea")
    : (project?.name
      ? project.name
      : t("project.unnamed", { id: project?.id })
    )

export const dynamicProjectNameText = (project: IProject, t: DynamicTranslate): string =>
  project && project.progress === ProjectProgress.Idea
    ? t("common", "project.idea")
    : (project?.name
      ? project.name
      : t("common", "project.unnamed", { id: project?.id })
    )

const ProjectNameText: React.FC<IProps> = ({ project }: IProps) => {
  const { t } = useTranslation("common")
  return <>{projectNameText(project, t)}</>
}

export default ProjectNameText